import React from 'react'
import contentfulClient from '../util/contentful-client'

export default class SourcesPage extends React.Component {
  state = {
    headline: '',
    body: '',
    sources: [],
    milestones: [],
    headline_timeline: '',
    headline_milestones: '',
    rubrikVision: '',
    sourcesVision: [],
  }

  componentDidMount() {
    contentfulClient
      .getEntries({
        content_type: 'sources',
        limit: 1,
      })
      .then((entries) => {
        let headline,
          body,
          sources,
          headline_timeline,
          headline_milestones,
          milestones,
          rubrikVision,
          sourcesVisions

        entries.items.forEach(({ fields }) => {
          if (fields.headline) {
            headline = fields.headline
            this.setState({ headline })
          }
          if (fields.headline_timeline) {
            headline_timeline = fields.headline_timeline
            this.setState({ headline_timeline })
          }

          if (fields.headline_milestones) {
            headline_milestones = fields.headline_milestones
            this.setState({ headline_milestones })
          }

          if (fields.rubrikVision) {
            rubrikVision = fields.rubrikVision
            this.setState({ rubrikVision })
          }

          if (fields.body) {
            body = fields.body
            this.setState({ body })
          }

          if (fields.kallhanvisningar) {
            sources = fields.kallhanvisningar.map(({ fields, sys }) => ({
              id: sys.id,
              text: fields.text,
            }))
          }
          if (fields.milstolpar) {
            milestones = fields.milstolpar.map(({ fields, sys }) => ({
              id: sys.id,
              text: fields.milstole,
            }))
          }
          if (fields.sourcesVision) {
            sourcesVisions = fields.sourcesVision.map(({ fields, sys }) => ({
              id: sys.id,
              text: fields.visionSourceItem,
            }))
          }
        })

        this.setState({ sources, milestones, sourcesVisions })
        console.log(sourcesVisions)
      })
  }

  get getSources() {
    if (!this.state.sources) return null

    return this.state.sources.map(({ text }, i) => (
      <p key={i} className="no-margins">
        {text}
      </p>
    ))
  }

  get getMilestones() {
    if (!this.state.milestones) return null

    return this.state.milestones.map(({ text }, i) => (
      <p key={i} className="no-margins">
        {text}
      </p>
    ))
  }

  get getSourcesVisions() {
    if (!this.state.sourcesVisions) return null

    return this.state.sourcesVisions.map(({ text }, i) => (
      <p key={i} className="no-margins">
        {text}
      </p>
    ))
  }

  get getBody() {
    if (!this.state.body) return null

    return <p>{this.state.body}</p>
  }

  get getHeadline() {
    return <h2>{this.state.headline}</h2>
  }

  get getheadline_timeline() {
    return <h5>{this.state.headline_timeline}</h5>
  }

  get getheadline_milestones() {
    return <h5>{this.state.headline_milestones}</h5>
  }

  get getrubrikVision() {
    return <h5>{this.state.rubrikVision}</h5>
  }

  render() {
    return (
      <div>
        <div className="row row-small mb-4">
          {this.getHeadline}
          {this.getBody}
        </div>
        <div className="row row-small text-left">
          {this.getheadline_milestones}
          {this.getMilestones}
        </div>

        <div className="row row-small text-left mt-2">
          {this.getheadline_timeline}
          {this.getSources}
        </div>

        <div className="row row-small text-left mt-2 mb-4">
          {this.getrubrikVision}
          {this.getSourcesVisions}
        </div>
      </div>
    )
  }
}
